import { useDispatch } from 'react-redux'
import dayjs from 'dayjs'
import Row from 'antd/es/grid/row'
import Col from 'antd/es/grid/col'
import { useAppSelector } from '@/redux/hooks.ts'
import { selectThemeStyle } from '@/features/setting/setting.slice.ts'
import {
  selectDashboardInput,
  setDashboardInputDateRange,
  setDashboardShowLiquidatedIdeas,
} from '@/redux/slices/dashboard-input.slice.ts'
import { convertPxToNumber } from '@/utils/helpers.ts'
import IdeyaRangePicker from '@/common/antd/ideya-rangepicker.tsx'
import { USER_CONTROL_COL } from '@/common/constants/user-controls-layout.ts'
import { ShowLiquidatedSwitch } from '@/pages/components/show-liquidated-switch.tsx'
import { useCallback } from 'react'
import { useFixedBreakpoint } from '@/common/hooks/use-is-mobile'

export const DashboardUserControls = () => {
  const themeStyle = useAppSelector(selectThemeStyle)
  const dispatch = useDispatch()
  const dashboardInput = useAppSelector(selectDashboardInput)
  const screens = useFixedBreakpoint()
  const isMobile = !screens.md

  // Write to dashboardInput slice instead of ideaListInput
  const handleLiquidatedChange = useCallback(
    (checked: boolean) => {
      dispatch(setDashboardShowLiquidatedIdeas(checked))
    },
    [dispatch]
  )

  return (
    <Row
      style={{ marginBottom: themeStyle.marginSM, width: '100%' }}
      gutter={[0, convertPxToNumber(themeStyle.marginBase)]}
      justify={'space-between'}
    >
      <Col xs={24} md={USER_CONTROL_COL.dateRange}>
        <IdeyaRangePicker
          value={[
            dayjs(dashboardInput.dateRange[0]),
            dayjs(dashboardInput.dateRange[1]),
          ]}
          onChange={(dates) => {
            dispatch(
              setDashboardInputDateRange([
                dates?.[0] ? dates[0].format('YYYY-MM-DD') : null,
                dates?.[1] ? dates[1].format('YYYY-MM-DD') : null,
              ])
            )
          }}
        />
      </Col>
      <Col xs={24} md={USER_CONTROL_COL.switch}>
        <ShowLiquidatedSwitch
          rowProps={
            isMobile ? { justify: 'start', wrap: true } : { justify: 'end' }
          }
          value={dashboardInput.showLiquidatedIdeas}
          onChange={handleLiquidatedChange}
        />
      </Col>
    </Row>
  )
}
